import type { Language } from '@seek/ca-myprofile-utils';
import { useLanguage, useTranslations } from '@vocab/react';
import { Secondary, Text, TextLink } from 'braid-design-system';

import analytics from 'src/modules/analytics/accountMiddlewareAnalytics';
import type { PageAnalytics } from 'src/reducers/page';
import type { UserDetails } from 'src/reducers/user';
import { getLanguagePrefixedPath } from 'src/utils/getLanguagePrefixedPath';

import translations from './.vocab';

interface Props {
  originator: string;
  pageAnalytics: PageAnalytics;
  userDetails?: UserDetails;
}

export const DontHavePasswordLink = (props: Props) => {
  const { originator, pageAnalytics, userDetails } = props;
  const { t } = useTranslations(translations);
  const { language } = useLanguage();

  const { siteCountry, brand, siteLanguage, zone } = pageAnalytics;

  const { trackLink } = analytics({
    pageAnalytics: {
      siteCountry,
      brand,
      siteLanguage,
      zone,
    },
  });

  return (
    <Text>
      <Secondary>
        {t('DontHavePassword', {
          TextLink: (children) => (
            <TextLink
              href={getLanguagePrefixedPath(
                language as Language,
                `/oauth/forgot-password`,
              )}
              weight="weak"
              hitArea="large"
              target="_blank"
              onClick={() =>
                trackLink({
                  currentPageSection: originator,
                  eventName: 'create_password_pressed',
                  ...userDetails,
                })
              }
            >
              {children}
            </TextLink>
          ),
        })}
      </Secondary>
    </Text>
  );
};
